import type { BogglePlaygroundSettings } from '~/boggle/config/playground'
import { getChallengeMinWordLengthInfo } from '~/boggle/gameModes/minWordLengthVariants'
import {
  getSprintChallengeIntervalCountInfo,
  getSprintChallengeIntervalTimeInfo,
} from '~/boggle/gameModes/sprintVariants'
import type { AnyBoggleChallengeCoreDefinition } from '~/boggle/gameModes/types'
import { BOGGLE_CHALLENGE_GRID_SIZE_CORE_DEFINITION } from '../shared/gridSizeCore'

export const SPRINT_CHALLENGE_CORE_DEFINITIONS = [
  BOGGLE_CHALLENGE_GRID_SIZE_CORE_DEFINITION,
  {
    createPatch: (value: number) => ({
      minWordLength: value,
    }),
    getInfo: getChallengeMinWordLengthInfo,
    id: 'min-word-length',
    label: 'Minimum Letters',
    readValue: (settings: BogglePlaygroundSettings) => settings.minWordLength,
    renderValue: (value: number) => value,
    isRow: true,
  },
  {
    createPatch: (value: number) => ({
      intervalCount: value,
    }),
    getInfo: getSprintChallengeIntervalCountInfo,
    id: 'interval-count',
    label: 'Intervals',
    readValue: (settings: BogglePlaygroundSettings) => settings.intervalCount ?? 1,
    renderValue: (value: number) => value,
  },
  {
    createPatch: (value: number) => ({
      intervalTimeSeconds: value,
    }),
    getInfo: getSprintChallengeIntervalTimeInfo,
    id: 'interval-time',
    label: 'Time',
    readValue: (settings: BogglePlaygroundSettings) => settings.intervalTimeSeconds,
    renderValue: (value: number) => value,
  },
] as const satisfies readonly AnyBoggleChallengeCoreDefinition[]
